// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".border-right[data-v-158f8c6a]{border-right:1px solid #fff}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/construction/rubber_components/ConstructionRequirementNewDialog.vue"],"names":[],"mappings":"AACA,+BACC,2BAAA","file":"ConstructionRequirementNewDialog.vue","sourcesContent":["\n.border-right {\n\tborder-right: 1px solid white;\n}\n"]}]);
// Exports
module.exports = exports;
